// Click adapters — תבניות קבועות שמתרגמות URL סופי לחתימת הקליק של המדיה.
// adapter הוא נתונים בלבד; אין כאן קוד חופשי. adapter לא מוכר דורש קונפיגורציה ואישור במערכת.
import { z } from 'zod';

export const ClickAdapterConfig = z.object({
  kind: z.enum(['clicktag-var', 'clicktag-query', 'none']),
  /** שם המשתנה כפי שהמפרט דורש — case sensitive (clickTag / clickTAG / clickTag1) */
  variableName: z.string().regex(/^[A-Za-z_$][A-Za-z0-9_$]{0,40}$/).default('clickTag'),
  /** ל-clicktag-query: שם הפרמטר ב-query של index.html */
  queryParam: z.string().regex(/^[A-Za-z0-9_]{1,40}$/).optional(),
  target: z.enum(['_blank', '_top']).default('_blank'),
  /** meta ad.size — רק אם המפרט דורש */
  adSizeMeta: z.boolean().default(false),
  /** האם הקליק על כל הבאנר או רק על CTA */
  clickArea: z.enum(['banner', 'cta']).default('banner'),
});
export type ClickAdapterConfig = z.infer<typeof ClickAdapterConfig>;

const js = (s: string) => JSON.stringify(s).replace(/</g, '\\u003c');

/** snippet ל-<head>: מגדיר את משתנה הקליק לפי האדפטר */
export function clickHeadScript(cfg: ClickAdapterConfig, resolvedUrl: string | null): string {
  if (cfg.kind === 'none') return 'window.__bbClick=null;';
  const v = cfg.variableName;
  if (cfg.kind === 'clicktag-var') {
    return `var ${v} = ${js(resolvedUrl ?? '')};\nwindow.__bbClick=function(){window.open(window[${js(v)}],${js(cfg.target)});};`;
  }
  // clicktag-query: ה-ad server מעביר את הכתובת ב-query; fallback לכתובת המוטמעת
  const qp = cfg.queryParam ?? v;
  return `var ${v} = (function(){try{var m=new RegExp('[?&]'+${js(qp)}+'=([^&]*)').exec(location.search);if(m)return decodeURIComponent(m[1]);}catch(e){}return ${js(resolvedUrl ?? '')};})();\nwindow.__bbClick=function(){window.open(window[${js(v)}],${js(cfg.target)});};`;
}
